export default __webpack_public_path__ + "static/media/Advisory.98c349d7.jpg";